(function() {
    'use strict';

    angular
        .module('pharmaPortalApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('pharma-fault-report-header', {
            parent: 'entity',
            url: '/pharma-fault-report-header?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'pharmaPortalApp.pharmaFaultReportHeader.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/pharma-fault-report-header/pharma-fault-report-headers.html',
                    controller: 'PharmaFaultReportHeaderController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('pharmaFaultReportHeader');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('pharma-fault-report-header-detail', {
            parent: 'entity',
            url: '/pharma-fault-report-header/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'pharmaPortalApp.pharmaFaultReportHeader.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/pharma-fault-report-header/pharma-fault-report-header-detail.html',
                    controller: 'PharmaFaultReportHeaderDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('pharmaFaultReportHeader');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PharmaFaultReportHeader', function($stateParams, PharmaFaultReportHeader) {
                    return PharmaFaultReportHeader.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'pharma-fault-report-header',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('pharma-fault-report-header.delete', {
            parent: 'pharma-fault-report-header',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/pharma-fault-report-header/pharma-fault-report-header-delete-dialog.html',
                    controller: 'PharmaFaultReportHeaderDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PharmaFaultReportHeader', function(PharmaFaultReportHeader) {
                            return PharmaFaultReportHeader.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('pharma-fault-report-header', null, { reload: 'pharma-fault-report-header' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('pharma-fault-report-header.history', {
            parent: 'pharma-fault-report-header',
            url: '/{id}/history',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/pharma-fault-report-header/pharma-fault-report-header-history-dialog.html',
                    controller: 'PharmaFaultReportHeaderHistoryController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        entity: ['PharmaFaultReportHeader', function(PharmaFaultReportHeader) {
                            return PharmaFaultReportHeader.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('pharma-fault-report-header', null, { reload: 'pharma-fault-report-header' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('pharma-fault-report-line-history', {
            parent: 'pharma-fault-report-header',
            url: '/{id}/lineHistory',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/pharma-fault-report-header/pharma-fault-report-line-history-dialog.html',
                    controller: 'PharmaFaultReportLineHistoryController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        entity: ['PharmaFaultReportLine', function(PharmaFaultReportLine) {
                            return PharmaFaultReportLine.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('pharma-fault-report-header', null, { reload: 'pharma-fault-report-header' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();
